var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [["C", "B#"], ["C#", "Db"], ["D"], ["D#", "Eb"], ["E", "Fb"], ["F", "E#"], ["F#", "Gb"], ["G"], ["G#", "Ab"], ["A"], ["A#", "Bb"], ["B", "Cb"]];
exports = exports["default"];
export default exports;